import { CodeSimple, Info, Link, UserCircleDashed } from '@phosphor-icons/react'
import { useContext, useState } from 'react'

import Ui from '@/ui'
import Tooltip from '@/ui/atoms/Tooltip'
import Modal from '@/ui/Modal'
import { ZentakeContext } from '@/utils/ZentakeContext'

import { AnonymousContent } from './AnonymousContent'
import { IframeContent } from './IframeContent'
import { URLLinkContent } from './URLLinkContent'

type Props = {
  publicUrl: string
  title: string
  onClose: () => void
}

export const PublicURLModal = ({ publicUrl, title, onClose }: Props) => {
  const [selectedTab, setSelectedTab] = useState('url-link')
  const { teamDetails } = useContext(ZentakeContext)

  const allowedTabs = [
    {
      id: 'url-link',
      title: (
        <>
          <Link className="text-lg" /> URL Link
        </>
      ),
    },
    {
      id: 'iframe',
      title: (
        <>
          <CodeSimple className="text-lg" /> Iframe
        </>
      ),
    },
    ...(teamDetails?.anonymous_link
      ? [
          {
            id: 'anonymous',
            title: (
              <>
                <UserCircleDashed className="text-lg" /> Anonymous
                <Tooltip title="Learn More">
                  <a
                    className="absolute right-1 top-1"
                    href="https://help.zentake.com/article/146-anonymous-forms?preview=6854753f316af23f5244381e"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Info className="text-lg text-gray-500" />
                  </a>
                </Tooltip>
              </>
            ),
          },
        ]
      : []),
  ]

  const currentSelectedTabs = allowedTabs.findIndex(
    (item) => item.id === selectedTab
  )

  const formattedTitle = `Public URL - ${title}`

  return (
    <Modal
      open
      footer={() => undefined}
      onCancel={onClose}
      {...{ title: formattedTitle }}
    >
      <Ui.Tabs
        className="mt-6 w-full [&>button]:!w-full"
        initialSelectedIndex={currentSelectedTabs}
        onSelectOption={({ id }: { id: string }) => setSelectedTab(id)}
        options={allowedTabs}
      />
      {selectedTab === 'url-link' ? (
        <URLLinkContent {...{ publicUrl }} />
      ) : null}
      {selectedTab === 'iframe' ? <IframeContent {...{ publicUrl }} /> : null}
      {selectedTab === 'anonymous' ? (
        <AnonymousContent {...{ publicUrl }} />
      ) : null}
    </Modal>
  )
}
